import {combineReducers} from 'redux';
import {allData} from './Reducers';

export default combineReducers({allData});
